import { Vue, Component, Prop, Ref, Watch } from "vue-property-decorator";
import { busy, IRestResult } from "@/loader";
import { BTable, BvTableFilterCallback } from "bootstrap-vue";

@Component
export class TableMixin extends Vue {
	@Prop({ type: Boolean, default: false })
	public hideFilters!: boolean;

	@Prop({ type: Boolean, default: false })
	public noPaging!: boolean;

	@Prop({ type: Boolean, default: false })
	public noSorting!: boolean;

	@Prop({ type: Number, default: 20 })
	public perPage!: number;

	@Prop({ type: String, default: null })
	public sortBy!: string | null;

	@Prop({ type: Boolean, default: false })
	public sortDesc!: boolean;

	// public get table(): BTable {
	// 	return this.$refs.table as BTable;
	// }

	@Ref("table")
	public readonly table!: BTable;

	public currentPage: number = 1;
	public totalRows: number = 0;
	public filter: string | RegExp | BvTableFilterCallback | null = null;

	public get isBusy(): boolean {
		return busy.status;
	}

	public refresh() {
		this.table.refresh();
	}

	public filterChanged() {
		if (this.currentPage !== 1) {
			this.currentPage = 1;
		} else {
			this.refresh();
		}
	}

	public setResult(callback: Function, result: IRestResult<any>) {
		if (result.success) {
			this.totalRows = result.total || result.items?.length || 0;
			this.$emit("total-rows", this.totalRows);
			callback(result.items);
		} else {
			this.totalRows = 0;
			this.$emit("total-rows", this.totalRows);
			callback([]);
		}
	}

	@Watch("filter")
	public searchFilterChanged(newValue?: string | RegExp | BvTableFilterCallback | null, oldValue?: string | RegExp | BvTableFilterCallback | null) {
		this.filterChanged();
	}
}
